import i18n from '@/lang'

const push = {
  namespaced: true,

  state: {
    pushDialog: {
      // 是否是任务类型，是的话要用task_id
      isTask: false,
      // 视频项目的推送是不是批量任务
      isBatchTask: false,
      // 是否是默认版本（目前在定制可玩有用）
      isDefaultVersion: false,
      templateId: '', // 同上isDefaultVersion一起用
      visible: false,
      width: '416px',
      title: i18n.t('playTurbo.common.pushDialog.title'),
      type: '',
      from: '',
      loading: false,
      projectName: '',
      nameOptions: [],
      appendToBody: true,
      cancleLabel: i18n.t('playTurbo.common.pushDialog.cancleLabel'),
      confirmLabel: i18n.t('playTurbo.common.pushDialog.confirmLabel'),
    },
    pushRecordDialog: {
      visible: false,
      currentItem: {},
      id: '',
      type: '', // material素材，playable 可玩素材， dco 组合
      from: '',
    },
    pushIds: '',
    basicId: 0,
  },

  mutations: {
    updatePushDialog: (state, value) => {
      state.pushDialog = {
        ...state.pushDialog,
        ...value,
      }
    },
    updatePushRecordDialog: (state, value) => {
      state.pushRecordDialog = {
        ...state.pushRecordDialog,
        ...value,
      }
    },
    setPushIds: (state, value) => {
      state.pushIds = value
    },
    setBasicId: (state, value) => {
      state.basicId = value
    },
  },

  actions: {
    showPushDialog({ commit }, opt) {
      commit('updatePushDialog', {
        ...opt,
        visible: true,
        type: opt.type || '',
        from: opt.from || '',
        projectName: opt.projectName || '',
        quality: opt.quality || '',
        isDefaultVersion: Boolean(opt.isDefaultVersion),
        templateId: opt.templateId || '',
      })
      commit('setPushIds', opt.ids)
    },
    resetPushDialog({ commit }) {
      commit('setPushIds', '')
    },
    hidePushDialog({ commit }) {
      commit('updatePushDialog', {
        isTask: false,
        isBatchTask: false,
        visible: false,
        type: '',
        from: '',
        projectName: '',
        nameOptions: [],
        isDefaultVersion: false,
        templateId: '',
      })
      commit('setPushIds', '')
    },
    showPushRecordDialog({ commit }, opt) {
      commit('updatePushRecordDialog', {
        visible: true,
        currentItem: opt.item,
        id: opt.id,
        from: opt.from,
        type: opt.type,
      })
    },
    hidePushRecordDialog({ commit }, id) {
      commit('updatePushRecordDialog', {
        visible: false,
        currentItem: {},
        id: '',
        from: '',
        type: '',
      })
    },
  },
}

export default push
